module.exports = __webpack_public_path__ + "static/img/DAVID_WARNER.ab0ea03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DAVID_WARNER.jpg
// module id = bmmi
// module chunks = 0